// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// https://medium.com/the-vue-point/vue-2-0-is-here-ef1f26acf4b8#.v65jchbsd
// https://github.com/vuejs/vue-hackernews-2.0/tree/master/src
// npm install vue-multiselect@next  -> https://www.npmjs.com/package/vue-multiselect
// https://github.com/vuejs/vue-validator
// http://vee-validate.logaretm.com/examples
// http://vee-validate.logaretm.com/
// http://vee-validate.logaretm.com/localization#attributes-data-as

import translate from './translate/translate'
// import locale from 'element-ui/lib/locale/lang/en'

import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import store from './vuex/store'
import DataApi from './api'
import ElementUI from 'element-ui'
import './assets/css/elements-dq/index.css'
import DqUI from './dq-ui'
import locale from 'element-ui/lib/locale/lang/en'
import UUID from 'vue-uuid'

// The destinationPages list is the list of pages we don't need to load simple-tree when route to them.
const destinationPages = ['user', 'location', 'till', 'cit', 'mix', 'report', 'softwaresettings', 'adminsettings']
// The previousPages list is the exceptional pages when routing from these pages we should always load simple-tree.
const previousPages = ['start', 'logout']
Vue.use(DataApi)
Vue.use(ElementUI, { locale })
Vue.use(VueResource)
Vue.use(DqUI, { })
Vue.use(UUID)


Vue.config.errorHandler = function (err, vm, info) {
  console.log(err)
}

router.beforeEach((to, from, next) => {
  // to and from are both route objects
  // start session check (if required)!
  if (to.name === 'generic.error.ErrorPage' && from.name === 'login' && store.getters['generalSession/getCurrentSession'].state === 'error') {
    return
  }
  if (!(to.meta && to.meta.authorize === false)) {
    store.commit('generalSession/checkSession', to)
    // due to performance optimization
    // do not call simple-tree each time

    if (
      from.path !== to.path && // Prevent re-triggering on query param change
      (from.name === null || previousPages.some(p => from.name.includes(p)) || !(destinationPages.some(e => to.name.includes(e))))
    ) {
      store.commit('generalOrganization/setOrganizationSimpleTree', to)
    }
    new Promise((resolve, reject) => {
      // do a thing, possibly async, then…
      var interval = setInterval(() => {
        if (store.getters['generalSession/getCurrentSession'].state === 'ready') {
          resolve('Stuff worked!')
          clearInterval(interval)
        } else
        if (store.getters['generalSession/getCurrentSession'].state === 'error') {
          console.log('It broke!')
          clearInterval(interval)
          reject({message: 'It broke', session: store.getters['generalSession/getCurrentSession']})
        }
      }, 100)
    }).then((response) => {
      return next()
    }, (response) => {
      console.log('error!!', response)
    })
  } else {
    next()
  }
})

/* eslint-disable no-new */
const vue = new Vue({
  router,
  store,
  translate,
  ...App
}).$mount('#app')

export { vue, router, DataApi, store, translate }



// WEBPACK FOOTER //
// ./src/main.js